import ApolloClient from "apollo-boost";

import { API } from "./settings";

const client = new ApolloClient({
  uri: `${API.BASE_URL}/graphql`,
});

export { client };
